import type { ReactNode } from "react";

export function PanelHeading({ icon, title, action }: { icon: JSX.Element; title: string; action?: ReactNode }) {
  return (
    <header className="panel-heading">
      <div>
        {icon}
        <strong>{title}</strong>
      </div>
      {typeof action === "string" ? <span>{action}</span> : action ?? null}
    </header>
  );
}

export function WorkflowNotice({ notice }: { notice: { tone: "info" | "success" | "warning"; message: string } }) {
  return (
    <div className={`workspace-notice ${notice.tone}`} role="status">
      {notice.message}
    </div>
  );
}
